<template>
  <Layout>
    <div class="container">
      <div class="row">
        <div class="card">
          <div class="card-header">
            <img src="../../public/img/LineAdmin_QR.png" alt="Profile Image" class="profile-img" />
          </div>
          <div class="card-body mt-5">
            <span class="brand-text">
              <b class="text-warning">FX</b>hanuman
            </span>
            <p class="username">LINE ID :: @FXhanuman</p>
            <p class="city">ช่องทางติดต่อสอบถาม</p>
            <p
              class="desc"
            >เปิดแอพ LINE > แท็บเพื่อน > แตะไอคอนเพิ่มเพื่อนเลือก "คิวอาร์โค้ด" จากนั้นจึงสแกนคิวอาร์โค้ด</p>
            <p>
              <a href="https://www.facebook.com/review.forex.broker/" class="social-icon facebook">
                <i class="fab fa-facebook-square fa-2x"></i>
              </a>
              <a href="https://line.me/ti/p/%40zhq5011b" class="social-icon line">
                <i class="fab fa-line fa-2x"></i>
              </a>
              <a
                href="https://www.youtube.com/channel/UCJHKmnPztDEay3ZKrEM4kYg/featured"
                class="social-icon youtube"
              >
                <i class="fab fa-youtube-square fa-2x"></i>
              </a>
            </p>
          </div>
          <div class="card-footer">
            <div class="col">
              <p>
                <span class="count">9.2K</span> Followers
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from "../components/Layout";

export default {
  name: "home",
  components: {
    Layout
  }
};
</script>

<style scoped>
.card {
  width: 700px;
  margin: 75px auto 0;
  background-color: #fff;
  box-shadow: 0 3px 30px rgba(0, 0, 0, 0.14);
  color: #444;
  text-align: center;
  font-size: 16px;
  height: 400px;
}

.card .card-header {
  position: relative;
  height: 48px;
}

.card .card-header .profile-img {
  width: 140px;
  height: 140px;
  /* border-radius: 1000px; */
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  border: 6px solid #fff;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
}

.card .card-body {
  padding: 10px 40px;
}

.card .card-body .brand-text {
  font-size: 20px;
  font-weight: 600;
  margin: 15px 0 0;
}

.card .card-body .username {
  font-size: 13px;
  color: #777;
  margin: 5px 0 0;
}

.card .card-body .city {
  font-weight: 500;
  margin: 10px 0 0;
}

.card .card-body .desc {
  line-height: 24px;
}

.card .social-icon {
  font-size: 18px;
  margin: 0 7px;
}

.card .social-icon.facebook {
  color: #3b5999;
}

.card .social-icon.line {
  color: #4ecd00;
}

.card .social-icon.youtube {
  color: #cd201f;
}

.card .card-footer {
  display: table;
  width: 100%;
  border-top: 1px solid #e6e6e6;
}

.card .card-footer .col {
  display: table-cell;
  padding: 5px 10px;
  font-size: 15px;
}

.card .card-footer .count {
  font-size: 18px;
  font-weight: 600;
}

@media screen and (max-width: 575px) {
  .card {
    width: 96%;
  }

  .card .card-body {
    padding: 10px 20px;
    margin-top: 15px;
  }

  .card .card-footer .col {
    padding: 0 10px;
  }

  .card .card-footer .count {
    display: block;
    margin-bottom: 5px;
  }
}
</style>
